import styled from "@emotion/styled";
import { Text } from "@totalenergiescode/mobility-business-rev-design-system";

export const StyledMenuItemText = styled(Text)<{
  color: string;
}>`
  ${({ color }) => `
color: ${color};
font-weight: 700;
`}
`;
